module.exports = __webpack_public_path__ + "static/media/static1.67ed678a.svg";